import 'bootstrap/dist/css/bootstrap.css';

import ReactDOM from "react-dom/client";
import "react-loading-skeleton/dist/skeleton.css";
import "react-quill/dist/quill.snow.css";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { ViewportProvider } from "./contexts";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
    <BrowserRouter>
        <ViewportProvider>
            <App />
        </ViewportProvider>
    </BrowserRouter>
);


